import React from 'react';
import UsersDetails from 'components/users/Details';
import CandidatesDetails from 'components/candidates/Details';
import Matches from 'components/candidates/Matches';

import {Button} from 'react-bootstrap'
import { Modal } from 'react-bootstrap';

export default props => {
  return (
    <div>
      <Modal show={props.selected} onHide={props.selectOne()}>
        <Modal.Header closeButton >
          <Modal.Title>Indepth: Candidate</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <CandidatesDetails {...props} />
          <UsersDetails.Container userId={props.selected.user} />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={props.selectOne()}>Close</Button>
        </Modal.Footer>

      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/candidates/Indepth.jsx